export default "__VITE_ASSET__DXAi0tAt__"